import { Stack } from "@chakra-ui/react";
import { useConfigurationMenu } from "@raiden/library/hooks/useConfigurationMenu";
import { memo } from "react";
import { MenuItem } from "./MenuItem";

export const Menu = memo(function Menu() {
  const { menu } = useConfigurationMenu({ alias: "footer" });

  if (!menu || menu.items.length === 0) {
    return null;
  }

  return (
    <Stack spacing="0.8125rem">
      {menu?.items?.map((menuItem, index) => {
        return <MenuItem menuItem={menuItem} key={index} />;
      })}
    </Stack>
  );
});
